import { QueryHookOptions } from "@apollo/client";
import {
  CustomGetWorksheetProductsQuery,
  CustomGetWorksheetProductsQueryVariables,
  useCustomGetWorksheetProductsQuery,
} from "generated/graphql";

export default function useGetWorksheetProducts(
  variables: CustomGetWorksheetProductsQueryVariables,
  baseOptions: QueryHookOptions<
    CustomGetWorksheetProductsQuery,
    CustomGetWorksheetProductsQueryVariables
  > = undefined
) {
  const { loading, data, error, refetch } = useCustomGetWorksheetProductsQuery({
    variables,
    ...baseOptions,
  });

  return {
    loading,
    error,
    data: (data?.getWorksheetProducts?.data ?? []) as NonNullable<
      CustomGetWorksheetProductsQuery["getWorksheetProducts"]
    >["data"],
    paginatorInfo: data?.getWorksheetProducts?.paginatorInfo ?? null,
    refetch,
  } as const;
}
